// RN web shims for libraries expecting Node globals
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const g: any = globalThis as any;
if (!g.global) g.global = g;
if (!g.process) g.process = { env: {} };

// Suppress expected console warnings for web (must be imported early)
import './Utils/consoleSuppress';

import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Minimal CSS-only fix for mobile devices - no event interference
// @ts-ignore - DOM types not available in this context
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // @ts-ignore
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                   // @ts-ignore
                   (navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
  
  if (isMobile) {
    // Only apply CSS fixes - let React Native Web handle events naturally
    const applyCSSFixes = () => {
      // @ts-ignore
      const doc: any = document;
      // @ts-ignore
      const win: any = window;
      
      // Just ensure touch events are initialized (one-time listener)
      doc.addEventListener('touchstart', () => {}, { passive: true, once: true });
      
      // Apply CSS fixes to interactive elements without interfering with events
      const fixInteractiveElements = () => {
        const interactiveElements = doc.querySelectorAll('div[style*="cursor: pointer"], button, a, [role="button"]');
        interactiveElements.forEach((el: any) => {
          const elem = el;
          // Only apply CSS, don't add event listeners
          elem.style.touchAction = 'manipulation';
          elem.style.webkitTapHighlightColor = 'transparent';
          elem.style.webkitTouchCallout = 'none';
          elem.style.pointerEvents = 'auto';
        });
      };
      
      // Run after React mounts
      setTimeout(fixInteractiveElements, 500);
      setTimeout(fixInteractiveElements, 1000);
    };
    
    // @ts-ignore
    if (document.readyState === 'loading') {
      // @ts-ignore
      document.addEventListener('DOMContentLoaded', applyCSSFixes);
    } else {
      applyCSSFixes();
    }
  }
}

// @ts-ignore - DOM types
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  // Ensure React Native Web's event system is initialized on mobile
  // Wait for React to fully mount before enabling interactions
  // @ts-ignore - DOM types
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // @ts-ignore
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     // @ts-ignore
                     (navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
    
    if (isMobile) {
      // Wait for React to fully mount and initialize its event system
      // Use requestAnimationFrame to ensure DOM is ready
      // @ts-ignore
      requestAnimationFrame(() => {
        // @ts-ignore
        requestAnimationFrame(() => {
          // Force React Native Web to initialize event listeners by ensuring document is ready
          // This doesn't interfere with events, just ensures the system is initialized
          const ensureEventSystemReady = () => {
            // Touch the document to ensure event listeners are attached
            // This is a no-op but ensures React Native Web's event system is active
            // @ts-ignore
            document.addEventListener('click', () => {}, { passive: true, once: true, capture: true });
            // @ts-ignore
            document.addEventListener('touchstart', () => {}, { passive: true, once: true, capture: true });
          };
          
          ensureEventSystemReady();
          
          // Also ensure after a short delay to catch late initialization
          setTimeout(ensureEventSystemReady, 100);
        });
      });
    }
    }
}
